export default "__VITE_ASSET__CvX9j4xK__"